/**
 * Total remaining units calculated from the remaining cases and units.
 *
 * @param {object} props
 * @param {number} props.remainingCases - The number of remaining cases.
 * @param {number} props.remainingUnits - The number of remaining units.
 * @param {number} props.unitsPerCase - The number of units per case.
 * @param {number} props.userDeclaredTotal - The total number of remaining units declared by the user.
 * @returns {JSX.Element}
 */
function Step2_RemainingItemsTotals({ remainingCases, remainingUnits, unitsPerCase, userDeclaredTotal }) {
    return (
        <div className="px-3 py-2">
            <div className="flex justify-between items-center">
                <span className="text-sm">Total Remaining Units:</span>
                <span className="text-sm">
                    ({remainingCases || 0} cases × {unitsPerCase || 0} units/case) + {remainingUnits || 0} loose units ={' '}
                    {userDeclaredTotal} units
                </span>
            </div>
        </div>
    );
}

export default Step2_RemainingItemsTotals;
